import { Statement } from '~support-at-home/models';

export interface BulkEmailFilterResult {
  emailableIds: string[];
  skippedCount: number;
}

/**
 * Filters selected statement IDs to only those whose client has an email address.
 * Returns the emailable IDs and the count of skipped statements.
 */
export function filterEmailableStatements(
  selectedIds: string[],
  statements: Statement[],
): BulkEmailFilterResult {
  const emailableIds = selectedIds.filter((selectedId) => {
    const statement = statements.find((st) => String(st.id) === selectedId);
    const email = statement?.client?.email;
    return typeof email === 'string' && email.trim().length > 0;
  });

  return {
    emailableIds,
    skippedCount: selectedIds.length - emailableIds.length,
  };
}
